export default __webpack_public_path__ + "static/media/326.6274a8ef.png";